<template>
  <span
    v-if="isVisible"
    class="material-icons-outlined atb-align-middle"
    @click="clickHandler"
  >
    {{ 'warning_amber' }}
  </span>
  <WherUsedModal
    :where-used-data="whereUsedData"
    ref="whereUsedModalRef"
  />
</template>

<script lang="ts" setup>
  import { WherUsedProps } from '@/app/shared/types/grid-cells/where-used-params.interface';
  import { Ref, ref, computed } from 'vue';
  import { AtbError } from '@/app/shared/types/errors/error.interface';
  import { useAlertStore } from '@/app/shared/stores/alert-store';
  import { Motif } from '@/app/shared/enums/motif-enum';
  import WherUsedModal from '@/app/features/ams/shared/WhereUsedModal.vue';
  import { useFiltersStore } from '@/app/features/ams/filters/filters-store';
  import { ModalActions } from '../../types/modal-actions.interface';
  import { useAttributesStore } from '@/app/features/ams/attributes/attributes-store';

  const filterStore = useFiltersStore();
  const attributeStore = useAttributesStore();

  interface WhereUsedProps {
    params: WherUsedProps;
  }

  const props = defineProps<WhereUsedProps>();
  const alertStore = useAlertStore();
  const whereUsedModalRef: Ref<ModalActions | null> = ref(null);

  const isVisible = computed(() => {
    return props.params?.value
  });

  const whereUsedData = computed(() => {
    const codeType = props.params.entity;
    return codeType == 'filter'
      ? filterStore.whereUsedData
      : attributeStore.whereUsedData;
  });

  const clickHandler = async () => {
    try {
      const { id } = props.params.data;
      props.params.whereUsedInfo(id);
      whereUsedModalRef.value?.changeModalVisibility();
    } catch (e) {
      const errorResponse = e as AtbError;
      alertStore.showNotification(
        errorResponse?.errors?.[0].error || 'Unkown error returned from server',
        'Error',
        Motif.ERROR
      );
    }
  };
</script>
